export class FetchAccessTokenFromRefreshTokenFailureAction {
    static readonly type = '[Auth] FetchAccessTokenFromRefreshTokenFailureAction';

    constructor(public payload: string) {}
}
